module.exports = __webpack_public_path__ + "img/uk_failure_4.a0e7c745.png";